<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguageOEMI(this.getUserInfo.OEMI,"SUB",obj_Group.I > 0? "ESUB": "ASUB")}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" v-if="!isOUTMOB">
                                    <div>
                                        <CRow>
                                            <!--Setup Sub Agent Title-->
                                            <CCol col="12">
                                                <h6 class="card-title section-title2" @click="showSectionBasedRole('ssa')">
                                                    <span>1</span>
                                                    {{this.getLanguage["SAS"]["SSA"]}}
                                                    <!-- Collapse Section Button -->
                                                    <i :class="setCollapseExpandIcon('SSA')"></i>
                                                </h6>                                               
                                            </CCol>
                                        </CRow>
                                        
                                        <template v-if="bool_showSSA">
                                            <!--row 1-->
                                            <CRow>
                                                <div class="col-md-6 form-group" v-if="getUserInfo.AT !== 4">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage["AG"]["G"]}}<span class="required" /> :</label>
                                                    <customtreeselect :multiple="false"
                                                                      :options="dd_agentgroup"
                                                                      :defaultExpandLevel="Infinity"
                                                                      :clearable="false"
                                                                      :flat="true"
                                                                      :placeholder="this.utilGetDDLanguage('AG.G')"
                                                                      v-model="obj_Group.PGIT"
                                                                      @input="ParentGroupChange"
                                                                      :disabled="obj_Group.I > 0"
                                                                      ref="PGI" />
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('PGI', 'G') }}</span>
                                                </div>

                                                <div class="col-md-4 form-group">
                                                    <label class="col-form-label-sm full-width">
                                                        {{ this.getLanguage['SMB']['SB'] }} - {{ this.getLanguage['ACT']['CUR'] }}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                    </label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_currency"
                                                                :placeholder="`${this.getLanguage['SMB']['SB']} - ${this.getLanguage['ACT']['CUR']}`"
                                                                v-model="obj_Group.DCI"
                                                                :clearable="false"
                                                                :disabled="obj_Group.I > 0"
                                                                ref="DCI" />
                                                    <span class="ErrMsg inline">{{ ValidationGroupErrMsg('DCI', 'DC') }}</span>
                                                </div>

                                                <div class="col-md-2 form-group" v-if="obj_Group.I <= 0 && !(searchSubBrand > 0) && getUserInfo.AT !== 4 && !bool_houtLockSB && checkModuleAccess3(constAccessType.edit)">
                                                    <div><label class="col-form-label-sm">{{getLanguage["SUB"]["GGE"]}}: </label></div>
                                                    <label class="switch">
                                                        <input type="checkbox"
                                                               :checked="obj_Group.IGGE"
                                                               @change="v => obj_Group.IGGE = v.target.checked"
                                                               :disabled="obj_Group.I > 0">
                                                        <span class="slider round darkGreenRound"></span>
                                                    </label>
                                                </div>

                                            </CRow>
                                            <!--row 2-->
                                            <CRow>
                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage["AG"]["PG"]}}<span class="required" v-if="getUserInfo.AT === 4" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :async="true"
                                                                :key="rtSubBrand"
                                                                :cacheOptions="bool_cacheOptionValue"
                                                                :load-options="loadSubBrandOptions"
                                                                :defaultOptions="ddDefaultSubBrand"
                                                                :options="ddSubBrandList"
                                                                :disable-branch-nodes="true"
                                                                :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                                :placeholder="getLanguage['AG']['PG']"
                                                                :disabled="obj_Group.I > 0"
                                                                @input="getMaxPT(1)"
                                                                v-model="searchSubBrand"
                                                                :v="$v.obj_Group.SAGAGI" />
                                                    <span class="ErrMsg" v-if="getUserInfo.AT === 4">{{ ValidationGroupErrMsg('SAGAGI', 'PG') }}</span>
                                                </div>

                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["SAS"]["SAN"]}}<span class="required" /> :</label>                                                      
                                                    <div class="inline" v-if="obj_Group.IGGE && obj_Group.I > 0">
                                                        <div class="custom_tooltip">
                                                            <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" class="nwithdraw-icon" />
                                                            <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">GGEarn</span>
                                                        </div>
                                                    </div>
                                                    <CInput :placeholder="getLanguage['SAS']['SAN']"
                                                            size="sm"
                                                            :value="obj_Group.GN"
                                                            @change="v => obj_Group.GN = v"
                                                            ref="GN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('GN', 'UDN')}}</span>
                                                </div>

                                                <div class="col-md-4 form-group">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage['SAS']['SAPC']}}<span class="required" /> : </label>
                                                    
                                                    <CInput :placeholder="getLanguage['SAS']['SAPC']"
                                                            size="sm"
                                                            v-model="obj_Group.PC"
                                                            class="inline uppercase inline50"
                                                            @change="ValidatePrefixCode()"
                                                            maxlength="8"
                                                            :disabled="obj_Group.I > 0"
                                                            ref="PC"></CInput>
                                                    <CButton class="inline inline10" :disabled="obj_Group.I > 0" color="outline-info" size="sm" @click="ValidatePrefixCode()" style="min-width: 30px;">
                                                        <span class='cil-search'></span>
                                                        <!--{{ getLanguage["BTN"]["CABT"] }}-->
                                                    </CButton>
                                                    <CButton class="inline" :disabled="obj_Group.I > 0" color="outline-info" size="sm" @click="GeneratePrefixCode()">
                                                        <span class='plusIcon cil-loop-circular'></span>
                                                        {{ getLanguage["BTN"]["GEN"] }}
                                                    </CButton>
                                                    <span :class="pc_msg_class" v-if="obj_Group.PC && obj_Group.I == 0">{{ValidationGroupErrMsg('PC')}}{{this.str_prefixError}}{{this.str_prefixCorrect}}</span>
                                                </div>

                                                <div class="col-md-2 form-group" v-if="!(searchSubBrand > 0) && getUserInfo.AT !== 4 && !bool_houtLockSB">
                                                    <div><label class="col-form-label-sm">{{getLanguage["SUB"]["OLT"]}}: </label></div>
                                                    <label class="switch">
                                                        <input type="checkbox"
                                                               :checked="obj_Group.IOL"
                                                               @change="v => obj_Group.IOL = v.target.checked"
                                                               :disabled="obj_Group.I > 0">
                                                        <span class="slider round darkGreenRound"></span>
                                                    </label>
                                                </div>
                                            </CRow>
                                            <div>
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["L"]}} <span class="required" /><span class="badge badge-success mx-2" style="background: #027202" v-if="obj_Group.Language && obj_Group.Language.length > 0">{{obj_Group.Language.length}}</span>:</label>
                                                <div class="card p-2 tempScrollbar" style="height: 100px; overflow: hidden scroll;">
                                                    <div class="row">
                                                        <!-- Supported Languages -->
                                                        <div class="col-md-3" v-for="lang in dd_languageSupport">
                                                            <div class="d-flex">
                                                                <input type="checkbox" :id="'lang'+lang.id" class="inline custom-checkbox" v-model="obj_Group.Language" :value="lang.id" />
                                                                <label :for="'lang'+lang.id" class="col-form-label-sm font-weight-bold ml-2">{{lang.label}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Language', 'L') }}</span>
                                            </div>
                                            <div>
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["C"]}} <span class="required" /><span class="badge badge-success mx-2" style="background: #027202" v-if="obj_Group.CurrencyIds && obj_Group.CurrencyIds.length > 0">{{obj_Group.CurrencyIds.length}}</span>:</label>
                                                <div class="card p-2 tempScrollbar" style="height: 100px; overflow: hidden scroll;">
                                                    <div class="row">
                                                        <!-- Supported Languages -->
                                                        <div class="col-md-2" v-for="cur in dd_currencySupport">
                                                            <div class="d-flex">
                                                                <input type="checkbox" :id="'cur'+cur.id" class="inline custom-checkbox" v-model="obj_Group.CurrencyIds" :value="cur.id" />
                                                                <label :for="'cur'+cur.id" class="col-form-label-sm font-weight-bold ml-2">{{cur.label}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('CurrencyIds', 'C') }}</span>
                                            </div>

                                            <!--row 3-->
                                            <CRow>
                                                <div class="col-md-6 form-group">
                                                    <label class="col-form-label-sm inline inline60">{{this.getLanguage["AG"]["WL"]}} :</label>
                                                    <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addMyIP()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["DM"]["MIP"]}}
                                                    </CButton>
                                                    <CInput class="inline inline60" :placeholder="getLanguage['AG']['WL']" size="sm" :value="obj_Group.WLIPS" @change="v => obj_Group.WLIPS = v"></CInput>
                                                    <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="addWhiteListIP()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                    </CButton>
                                                    <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                    <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                    <th>{{this.getLanguage['AG']['WL']}}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if="obj_Group.WhiteListIP == 0 || !obj_Group.WhiteListIP">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_Group.WhiteListIP">
                                                                <td>
                                                                    <span id="actionBtnCol">
                                                                        <i class="cil-trash" @click='removeWhiteListIP(index)'></i> <!--here Remove -->
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ data.WLIPS }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </CRow>
                                                </div>
                                            </CRow>
                                        </template>
                                    </div>

                                    <div>
                                        <CRow>
                                            <!--Setup Position Taking (PT) Title-->
                                            <CCol col="12">
                                                <h6 class="card-title section-title2" @click="showSectionBasedRole('spt')">
                                                    <span>2</span>
                                                    {{this.getLanguage["SAS"]["SPT"]}}
                                                    <!-- Collapse Section Button -->
                                                    <i :class="setCollapseExpandIcon('SPT')"></i>
                                                </h6>
                                            </CCol>
                                        </CRow>

                                        <template v-if="bool_showSPT">

                                            <!--<h5>{{this.getLanguage["AG"]["PT"]}}</h5>-->
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm full-width">{{this.getLanguage["SAPS"]["PT"]}}<span class="required" /> :<span class="float-right label-tooltip" style="padding-right:1%;">{{ formatNumber(selectedMinPT, 2, '') }} - {{ formatNumber(selectedMaxPT, 2, '') }}</span></label>
                                                    <CInput vertical size="sm" type="number" step="5" :value="obj_Group.SubAgentPayoutScheme.PT" @change="v => obj_Group.SubAgentPayoutScheme.PT = v" />
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SubAgentPayoutScheme.PT','PT') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group" v-if="!(searchSubBrand > 0) && getUserInfo.AT !== 4">
                                                    <label class="col-form-label-sm">{{this.getLanguage["SAPS"]["TYP"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="constSubAgentType"
                                                                :defaultExpandLevel="Infinity"
                                                                :clearable="false"
                                                                :placeholder="this.utilGetDDLanguage('SAPS.TYP')"
                                                                v-model="obj_Group.SubAgentPayoutScheme.WLT"
                                                                :disabled="obj_Group.I > 0 || (obj_Group.IGGE && obj_Group.SubAgentPayoutScheme.WLT == 1)"
                                                                @change="v => obj_Group.SubAgentPayoutScheme.WLT = v">
                                                        <div slot="value-label" slot-scope="{ node }">{{ utilGetErrorLanguage('SAPS.' + node.label) }}</div>
                                                        <label slot="option-label" slot-scope="{ node }">
                                                            {{ utilGetErrorLanguage('SAPS.' + node.label) }}
                                                        </label>
                                                    </treeselect>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SubAgentPayoutScheme.POT','TYP') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group" v-if="!(searchSubBrand > 0) && getUserInfo.AT !== 4">
                                                    <label class="col-form-label-sm">{{this.getLanguage["SAPS"]["SC"]}}<span class="required" /> :</label>
                                                    <treeselect :multiple="false"
                                                                :options="constSubAgentSchemeType"
                                                                :defaultExpandLevel="Infinity"
                                                                :clearable="false"
                                                                :placeholder="this.utilGetDDLanguage('SAPS.SC')"
                                                                v-model="obj_Group.SubAgentPayoutScheme.POT"
                                                                :disabled="obj_Group.I > 0"
                                                                @change="v => obj_Group.SubAgentPayoutScheme.POT = v">
                                                        <div slot="value-label" slot-scope="{ node }">{{ utilGetErrorLanguage('SAPS.' + node.label) }}</div>
                                                        <label slot="option-label" slot-scope="{ node }">
                                                            {{ utilGetErrorLanguage('SAPS.' + node.label) }}
                                                        </label>
                                                    </treeselect>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SubAgentPayoutScheme.WLT','SC') }}</span>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="4" class="form-group" v-for="(data,index) in arr_CustomProvider" v-bind:key="data.id">
                                                    <label class="col-form-label-sm full-width">{{renderProviderName(data.PN)}} : <span class="float-right label-tooltip" style="padding-right:1%;">{{ formatNumber(selectedMinPT, 2, '') }} - {{ formatNumber(data.MPT, 2, '') }}</span></label>
                                                    <CInput vertical size="sm" type="number" step="5" :value="data.PT" @change="v => data.PT = v" />
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                    <div v-if="obj_Group.I==0">
                                        <CRow>
                                            <!--Setup Sub Agent User Role  Title-->
                                            <CCol col="12">
                                                <h6 class="card-title section-title2" @click="showSectionBasedRole('ssaur')">
                                                    <span>3</span>
                                                    {{this.getLanguage["SAS"]["SSAUR"]}}
                                                    <!-- Collapse Section Button -->
                                                    <i :class="setCollapseExpandIcon('SSAUR')"></i>
                                                </h6>
                                            </CCol>
                                        </CRow>
                                        <template v-if="bool_showSSAUR">                                           
                                            <CRow>
                                                <CCol class="col-md-3 form-group">
                                                    <label class="col-form-label-sm full-width">
                                                        {{this.getLanguage["AG"]["RA"]}}<span class="required" /> :
                                                    </label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_access"
                                                                v-model="obj_Group.CA"
                                                                :clearable="false"
                                                                :disabled="obj_Group.I > 0"
                                                                ref="DCI" />
                                                    <span class="ErrMsg inline">{{ ValidationGroupErrMsg('CA', 'RA') }}</span>
                                                </CCol>
                                                
                                            </CRow>
                                            <CRow>
                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}}<span class="required" /> :</label>
                                                    <CInput :placeholder="getLanguage['AG']['UU']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.U"
                                                            @change="v => obj_Group.Agent.U = v"
                                                            ref="Agent.U"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.U', 'UU') }}</span>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["UDN"]}}<span class="required" /> :</label>
                                                    <CInput :placeholder="getLanguage['AG']['UDN']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.DN"
                                                            @change="v => obj_Group.Agent.DN = v"
                                                            ref="Agent.DN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.DN', 'UDN') }}</span>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["UUP"]}}<span class="required" />
                                                        <div class="custom_tooltip" style="position: unset;">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                                                        </div>:
                                                    </label>
                                                    <CInput type="password"
                                                            :placeholder="getLanguage['AG']['UUP']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.UP"
                                                            @change="v => obj_Group.Agent.UP = v"
                                                            ref="Agent.UP"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.UP', 'UUP') }}</span>
                                                </div>
                                                <div class="col-md-3 form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["AG"]["UCUP"]}}<span class="required" /> :</label>
                                                    <CInput type="password"
                                                            :placeholder="getLanguage['AG']['UCUP']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.CUP"
                                                            @change="v => obj_Group.Agent.CUP = v"
                                                            ref="Agent.CUP"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.CUP', 'UCUP') }}</span>
                                                </div>
                                               
                                            </CRow>
                                            <CRow>
                                                <div class="col-md-6 form-group">
                                                    <CInput :label="getLanguage['AG']['UE'] + ' :'"
                                                            :placeholder="getLanguage['AG']['UE']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.E"
                                                            @change="v => obj_Group.Agent.E = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.E', 'UE') }}</span>
                                                </div>
                                                <div class="col-md-6 form-group">
                                                    <CInput :label="getLanguage['AG']['UPN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['UPN']"
                                                            size="sm"
                                                            :value="obj_Group.Agent.PN"
                                                            @change="v => obj_Group.Agent.PN = v"></CInput>
                                                </div>
                                            </CRow>
                                        </template>
                                    </div>

                                    <div>
                                        <CRow>
                                            <!--Contact List Title-->
                                            <CCol col="12">
                                                <h6 class="card-title section-title2" @click="showSectionBasedRole('cl')">
                                                    <span>4</span>
                                                    {{this.getLanguage["CU"]["CUL"]}}
                                                    <!-- Collapse Section Button -->
                                                    <i :class="setCollapseExpandIcon('CL')"></i>
                                                </h6>
                                            </CCol>
                                        </CRow>
                                        <template v-if="bool_showCL">
                                            <CRow>
                                                <CCol col="12">
                                                    <CTabs variant="tabs" id="contactTab">
                                                        <!-- Finance Contact Tab -->
                                                        <CTab :title="getLanguage['SUB']['FC']" :active="blnFCOC === false ? true: false">
                                                            <CRow>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['GAME']['NM'] + ' :'"
                                                                            :placeholder="getLanguage['GAME']['NM']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].CN"
                                                                            @change="v => obj_Group.Contact[0].CN = v"></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['AG']['UPN'] + ' :'"
                                                                            :placeholder="getLanguage['AG']['UPN']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].PN"
                                                                            @change="v => obj_Group.Contact[0].PN = v">></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['MEM']['TGID'] + ' :'"
                                                                            :placeholder="getLanguage['MEM']['TGID']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].T"
                                                                            @change="v => obj_Group.Contact[0].T = v">></CInput>
                                                                </CCol>
                                                            </CRow>
                                                            <CRow>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['AG']['UE'] + ' :'"
                                                                            :placeholder="getLanguage['AG']['UE']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].E"
                                                                            @change="v => obj_Group.Contact[0].E = v">></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['SUB']['SKYPE'] + ' :'"
                                                                            :placeholder="getLanguage['SUB']['SKYPE']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].S"
                                                                            @change="v => obj_Group.Contact[0].S = v">></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['SUB']['OTHCT'] + ' :'"
                                                                            :placeholder="getLanguage['SUB']['OTHCT']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[0].OC"
                                                                            @change="v => obj_Group.Contact[0].OC = v">></CInput>
                                                                </CCol>
                                                            </CRow>                                                           
                                                        </CTab>

                                                        <!-- Operation Contact Tab -->
                                                        <CTab :title="getLanguage['SUB']['OC']" :active="blnFCOC === true ? true: false">
                                                            <CRow>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['GAME']['NM'] + ' :'"
                                                                            :placeholder="getLanguage['GAME']['NM']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].CN"
                                                                            @change="v => obj_Group.Contact[1].CN = v"></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['AG']['UPN'] + ' :'"
                                                                            :placeholder="getLanguage['AG']['UPN']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].PN"
                                                                            @change="v => obj_Group.Contact[1].PN = v"></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['MEM']['TGID'] + ' :'"
                                                                            :placeholder="getLanguage['MEM']['TGID']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].T"
                                                                            @change="v => obj_Group.Contact[1].T = v"></CInput>
                                                                </CCol>
                                                            </CRow>
                                                            <CRow>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['AG']['UE'] + ' :'"
                                                                            :placeholder="getLanguage['AG']['UE']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].E"
                                                                            @change="v => obj_Group.Contact[1].E = v"></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['SUB']['SKYPE'] + ' :'"
                                                                            :placeholder="getLanguage['SUB']['SKYPE']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].S"
                                                                            @change="v => obj_Group.Contact[1].S = v"></CInput>
                                                                </CCol>
                                                                <CCol class="col-md-4 form-group">
                                                                    <CInput :label="getLanguage['SUB']['OTHCT'] + ' :'"
                                                                            :placeholder="getLanguage['SUB']['OTHCT']"
                                                                            size="sm"
                                                                            :value="obj_Group.Contact[1].OC"
                                                                            @change="v => obj_Group.Contact[1].OC = v"></CInput>
                                                                </CCol>
                                                            </CRow>
                                                        </CTab>
                                                    </CTabs>
                                                </CCol>
                                            </CRow>
                                        </template>
                                    </div>
                                </div>
                                <div class="modal-main-content" v-if="isOUTMOB">
                                    <div>
                                        <CRow>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">{{this.getLanguage["AG"]["PG"]}}<span class="required" v-if="getUserInfo.AT === 4" /> :</label>
                                                <treeselect :multiple="false"
                                                            :async="true"
                                                            :key="rtSubBrand"
                                                            :cacheOptions="bool_cacheOptionValue"
                                                            :load-options="loadSubBrandOptions"
                                                            :defaultOptions="ddDefaultSubBrand"
                                                            :options="ddSubBrandList"
                                                            :disable-branch-nodes="true"
                                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                            :placeholder="getLanguage['AG']['PG']"
                                                            :disabled="obj_Group.I > 0"
                                                            @input="getMaxPT(1)"
                                                            v-model="searchSubBrand"
                                                            :v="$v.obj_Group.SAGAGI" />
                                                <span class="ErrMsg" v-if="getUserInfo.AT === 4">{{ ValidationGroupErrMsg('SAGAGI', 'PG') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{this.getLanguage['AG']['DC']}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                </label>
                                                <treeselect :multiple="false"
                                                            :options="dd_currency"
                                                            :placeholder="getLanguage['AG']['DC']"
                                                            v-model="obj_Group.DCI"
                                                            :clearable="false"
                                                            :disabled="obj_Group.I > 0"
                                                            ref="DCI" />
                                                <span class="ErrMsg inline">{{ ValidationGroupErrMsg('DCI', 'DC') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{this.getLanguage['AG']['C']}}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                </label>
                                                <treeselect :multiple="true"
                                                            :options="dd_currencySupport"
                                                            :defaultExpandLevel="1"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :placeholder="getLanguage['AG']['C']"
                                                            v-model="obj_Group.CurrencyIds"
                                                            :clearable="false"
                                                            @input="getMaxPT(1)"
                                                            ref="CurrencyIds" />
                                                <span class="ErrMsg inline">{{ ValidationGroupErrMsg('CurrencyIds', 'C') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">
                                                    {{this.getLanguage['AG']['L']}}<span class="required" /> :
                                                </label>
                                                <treeselect :multiple="true"
                                                            :options="dd_languageSupport"
                                                            :defaultExpandLevel="1"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :placeholder="getLanguage['AG']['L']"
                                                            v-model="obj_Group.Language"
                                                            :clearable="false"
                                                            ref="Languages" />
                                                <span class="ErrMsg inline">{{ ValidationGroupErrMsg('Language', 'L') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['PC']}}<span class="required" /> : </label>
                                                <CInput :placeholder="getLanguage['AG']['PC']"
                                                        size="sm"
                                                        v-model="obj_Group.PC"
                                                        class="inline uppercase inline50"
                                                        @change="ValidatePrefixCode()"
                                                        maxlength="8"
                                                        :disabled="obj_Group.I > 0"
                                                        ref="PC"></CInput>
                                                <CButton class="inline inline50" :disabled="obj_Group.I > 0" color="outline-info" size="sm" @click="GeneratePrefixCode()">
                                                    <span class='plusIcon cil-loop-circular'></span>
                                                    {{ getLanguage["BTN"]["GEN"] }}
                                                </CButton>
                                                <span :class="pc_msg_class">{{ValidationGroupErrMsg('PC')}}{{this.str_prefixError}}{{this.str_prefixCorrect}}</span>
                                            </div>

                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UDN"]}}<span class="required" /> :</label>
                                                <CInput :placeholder="getLanguage['AG']['UDN']"
                                                        size="sm"
                                                        :value="obj_Group.GN"
                                                        @change="v => obj_Group.GN = v"
                                                        ref="GN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('GN', 'UDN')}}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm full-width">{{this.getLanguage['GL']['S']}} : </label>
                                                <treeselect :multiple="false"
                                                            :options="dd_status"
                                                            :clearable="false"
                                                            :placeholder="getLanguage['GL']['S']"
                                                            v-model="obj_Group.RS"
                                                            :disabled="obj_Group.I > 0 && (getUserInfo.AT > 0 || obj_Group.PRS == 1)" />
                                            </div>
                                        </CRow>
                                    </div>
                                    <div>
                                        <CRow>
                                            <!--Downline Setting Title-->
                                            <CCol col="12">
                                                <h6 class="card-title section-title2"><span>1</span>{{this.getLanguage["AG"]["DS"]}}</h6>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <div class="col-md-6 form-group" v-if="obj_Group.I==0">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}}<span class="required" /> :</label>
                                                <CInput :placeholder="getLanguage['AG']['UU']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.U"
                                                        @change="v => obj_Group.Agent.U = v"
                                                        ref="Agent.U"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.U', 'UU') }}</span>
                                            </div>
                                        </CRow>
                                        <CRow>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UUP"]}}<span class="required" /> :</label>
                                                <CInput type="password"
                                                        :placeholder="getLanguage['AG']['UUP']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.UP"
                                                        @change="v => obj_Group.Agent.UP = v"
                                                        ref="Agent.UP"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.UP', 'UUP') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UCUP"]}}<span class="required" /> :</label>
                                                <CInput type="password"
                                                        :placeholder="getLanguage['AG']['UCUP']"
                                                        size="sm"
                                                        :value="obj_Group.Agent.CUP"
                                                        @change="v => obj_Group.Agent.CUP = v"
                                                        ref="Agent.CUP"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.CUP', 'UCUP') }}</span>
                                            </div>
                                            <div class="col-md-6 form-group" v-if="obj_Group.I == 0">
                                                <label class="col-form-label-sm full-width">
                                                    {{this.getLanguage["AG"]["RA"]}}<span class="required" /> :
                                                </label>
                                                <treeselect :multiple="false"
                                                            :options="dd_access"
                                                            v-model="obj_Group.CA"
                                                            :clearable="false"
                                                            :disabled="obj_Group.I > 0"
                                                            ref="DCI" />
                                                <span class="ErrMsg inline">{{ ValidationGroupErrMsg('CA', 'RA') }}</span>
                                            </div>
                                        </CRow>
                                    </div>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveGroup()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isTopup && isOUTMOB">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:600px;"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription">
                        <CCard style="height:100%;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["SACH"]["TC"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd1">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow:inherit;">
                                    <CRow v-if="getUserInfo.AT !== 4">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["G"]}}* :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroupfs"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                              v-model="obj_Balance.PGIT"
                                                              @input="ParentGroupChange2" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["SUB"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :cacheOptions="bool_cacheOptionValue"
                                                        :load-options="loadSubBrandOptions2"
                                                        :defaultOptions="ddDefaultSubBrand2"
                                                        :options="ddSubBrandList2"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="getLanguage['AG']['SUB']"
                                                        v-model="obj_Balance.AGIT"
                                                        @input="AgentGroupChange2"
                                                        disabled />
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Balance.AGIT', 'SUB') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["SACH"]["CB"]}}</label>
                                            <CInput :placeholder="getLanguage['SACH']['CB']"
                                                    size="sm"
                                                    :value="obj_Balance.CB" disabled></CInput>
                                            <span class="ErrMsg"></span>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Balance.BT!=99">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["AG"]["BTUA"]}} ({{ this.str_currencysymbol }})<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ this.getLanguage['AG']['SBAB']}} : {{ this.AvailableBalanceAmount() }}</span>
                                            </label>
                                            <CInput :placeholder="getLanguage['AG']['BTUA']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_Balance.BU, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_Balance.BU = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Balance.BU', 'BTUA') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="updateBalance()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["AG"]["TUSB"] }}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeQRCodePreview()">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <!-- Generate QR Code based on Link -->
                                    <img v-if="previewUrl" :src="'data:image/png;base64,' + previewUrl" alt="QR Code" class="img-fluid">
                                    <p v-else>{{ getLanguage['GL']['NR'] }}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage["SMB"]["SUB"]}} </h2>
                        <CButton size="sm" color="outline-info" @click="addGroup()" v-if="checkModuleAccess2(constAccessType.add)"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <!--<div class='searchCol'>
                            <span class='searchLabel'>{{this.getLanguage["AG"]["GN"]}} :</span>
                            <CInput size="sm" :value="arr_FV['GN']" @change="v => arr_FV['GN'] = v"></CInput>
                        </div>-->
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["PG"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupFilter"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                  :clearable="false"
                                                  v-model="arr_FV['AGI']"
                                                  @input="loadDefaultSubBrand(arr_FV['AGI'])" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubBrandList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["AFF"]["T"]}} :</span>
                                <CInput size="sm" v-model="arr_FV['AL']"></CInput>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="!isOUTMOB">
                                <span class='searchLabel'>{{this.getLanguage["AG"]["PC"]}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper '>
                <header class="table-header d-flex">
                    <div class="d-md-flex align-items-center">
                        <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB",'MSL')}}</strong>
                        <div class="ml-0 ml-md-2">
                            <span v-if="this.getUserInfo.AT == 4 && this.getUserInfo.IOL" style="white-space: pre;">
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                            <span v-else-if="this.getUserInfo.AT == 4 && !this.getUserInfo.IOL" style="white-space: pre;">
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                            <span v-else>
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                        </div>
                    </div>

                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue' v-if="!isOUTMOB">
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["SMA"]["S"] }}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AFF"]["T"] }}<i @click="setSortTable('AL')" :class="setSortLogo('AL')" class="sortlogo"></i></th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>{{ this.getLanguage["DM"]["D"] }}</th>
                                <th>{{ this.getLanguage["AG"]["QRC"] }}</th>
                                <th class="tableCtnRight">{{ this.getLanguage["MTA"]["TM1"] }}<i @click="setSortTable('CDBL')" :class="setSortLogo('CDBL')" class="sortlogo"></i></th>
                                <!--<th>{{ this.getLanguage["AG"]["GT"] }}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>-->
                                <th>{{ this.getLanguage["APT"]["APT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["CR"]["CB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["CT"] }}
                                            <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["GL"]["UB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["UTS"] }}
                                            <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <table class='custom-table afb-blue' v-if="isOUTMOB">
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                </th>
                                <th class="tableCtnRight">{{ this.getLanguage["MTA"]["TM1"] }}<i @click="setSortTable('CDBL')" :class="setSortLogo('CDBL')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["SMA"]["S"] }}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' v-if="!isOUTMOB">
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["SMA"]["S"] }}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["AFF"]["T"] }}<i @click="setSortTable('AL')" :class="setSortLogo('AL')" class="sortlogo"></i></th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="margin-top: 9px;"></i>
                                </th>
                                <th>{{ this.getLanguage["DM"]["D"] }}</th>
                                <th>{{ this.getLanguage["AG"]["QRC"] }}</th>
                                <th class="tableCtnRight">{{ this.getLanguage["MTA"]["TM1"] }}<i @click="setSortTable('CDBL')" :class="setSortLogo('CDBL')" class="sortlogo"></i></th>
                                <!--<th>{{ this.getLanguage["AG"]["GT"] }}<i @click="setSortTable('AT')" :class="setSortLogo('AT')" class="sortlogo"></i></th>-->
                                <th>{{ this.getLanguage["APT"]["APT"] }}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["PG"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["CR"]["CB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["CT"] }}
                                            <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["GL"]["UB"] }}</span>
                                        <span class="grid-line">
                                            {{ this.getLanguage["GL"]["UTS"] }}
                                            <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i>
                                        </span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Group.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Group">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)">
                                        <i class="cil-color-border" @click="editGroup(data)"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AAGI != curAGI)">
                                        <i class="cil-color-border"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)">
                                        <i class="cil-cash" @click='openBalanceHistoryList(data)'></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["HTR"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="(isSENS == 1 && data.AAGI != curAGI)">
                                        <i class="cil-cash"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["HTR"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="((isSENS == 1 && data.AAGI == curAGI) || (isSENS == 0 && !isOUTLET))">
                                        <i class="cil-browser" @click='domainList(data.AAGI, data.I, data.AT)'></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["LST"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="(isSENS == 1 && data.AAGI != curAGI)">
                                        <i class="cil-browser"></i>
                                        <span class="tooltiptext">{{getLanguage["BTN"]["LST"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td class="text-center">
                                <label class="switch" v-if="checkModuleAccess2(constAccessType.edit) && (getUserInfo.AT==0 || getUserInfo.AT==4) && data.PRS==2 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)">
                                    <input type="checkbox" :checked="checkStatus(data.RS)" @click="updateStatus(index)" v-model="data.RS" true-value="2" false-value="1">
                                    <span class="slider round"></span>
                                </label>
                                <span v-else :class="(data.RS == 2) ? 'positive-number': 'negative-number'">{{checkStatusTemp(data.RS)}}</span>
                            </td>
                            <td>{{ data.AL }}</td>
                            <td>
                                <div class="d-flex align-items-center" style="gap:10px;">
                                    <span>
                                        <i class=" " :class="[data.IOL?'fa-solid fa-house theme-outlet ml-2':'fas fa-users theme-subagent ml-2']"></i>
                                        <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                    </span>
                                    <div>
                                        <span class="grid-line">{{ data.GN }}</span>
                                        <span class="grid-line">({{ data.PC }})</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.IGGE">
                                        <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" class="nwithdraw-icon" />
                                        <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">GGEarn</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span v-if="data.DN.Length != 0">
                                    <span class="grid-line edit-link" v-for="dn in data.DN">
                                        {{ dn }}
                                    </span>
                                </span>
                                <span v-else>-</span>
                            </td>
                            <td>
                                <a href="javascript:void(0)" style="color:blue" @click="generateQRCode(data.DN)" v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0) && data.DN.length != 0">
                                    <u> Show QR Code </u>
                                </a>
                                <span v-else>
                                    <span v-if="(isSENS == 1 && data.AGI != curAGI)"><!-- Blank --></span>
                                    <span v-else><!-- Blank --></span>
                                </span>
                            </td>
                            <td class="tableCtnRight">
                                <span :class="(data.CDBL >= 0) ? 'positive-number d-block': 'negative-number d-block'">
                                    <div class="custom_tooltip">
                                        {{ formatNumber(data.CDBL, 2, data.CS) }}
                                        <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["AG"]["SB"]}}</span>
                                    </div>
                                </span>
                                <span class="d-block" v-if="data.IGGE && data.GGEAWA > 0">
                                    <div class="custom_tooltip" >
                                        {{ formatNumber(data.GGEAWA, 2, data.CS) }}
                                        <span class="tooltiptext" style="background-color: black; color: white; position: absolute;">GGEarn {{getLanguage["MTA"]["AWRA"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>
                                <!--<span class="grid-line">{{ data.PayoutScheme }}</span>-->
                                <span class="grid-line">{{ data.SAGPT }}%</span>
                            </td>
                            <td v-if="data.PPC!=''">
                                <span class="grid-line">{{ data.PGN }}</span>
                                <span class="grid-line">({{ data.PPC }})</span>
                                <!--<span class="grid-line">{{ data.PGI }}</span>-->
                            </td>
                            <td>
                                <div class="d-inline-block">
                                    <span class="grid-line">{{ data.CB }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }} </span>
                                </div>
                            </td>
                            <td>
                                <div class="d-inline-block">
                                    <span class="grid-line">{{ data.UB }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }} </span>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <table class='custom-table afb-blue' v-if="isOUTMOB">
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>
                                    <div class="d-inline-block">
                                        <span class="grid-line">{{ this.getLanguage["AG"]["GN"] }}</span>
                                        <span class="grid-line">({{ this.getLanguage["AG"]["PC"] }})</span>
                                    </div>
                                    <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo" style="'margin-top: 9px;'"></i>
                                </th>
                                <th class="tableCtnRight">{{ this.getLanguage["MTA"]["TM1"] }}<i @click="setSortTable('CDBL')" :class="setSortLogo('CDBL')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["GL"]["ACT"] }}</th>
                                <th>{{ this.getLanguage["SMA"]["S"] }}<i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Group.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Group">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <span class="mr-2">
                                        <i class=" " :class="[data.IOL?'fa-solid fa-house theme-outlet ml-2':'fas fa-users theme-subagent ml-2']"></i>
                                        <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                    </span>
                                    <div>
                                        <span class="grid-line">{{ data.GN }}</span>
                                        <span class="grid-line">({{ data.PC }})</span>
                                    </div>
                                </div>
                            </td>
                            <td :class="(data.CDBL >= 0) ? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.CDBL, 2, data.CS) }}</td>
                            <td>
                                <span id="actionBtnCol">
                                    <CButton size="sm" type="button" class="btn-warning font-weight-bold text-white mr-2" @click="editGroup(data)" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0) && (isOUTMOB)">
                                        {{getLanguage["BTN"]["ED"]}}
                                    </CButton>
                                    <CButton size="sm" type="button" class="btn-warning font-weight-bold text-white mr-2" @click="adjustSystemBalance(data, 1)" v-if="(isOUTMOB)">
                                        {{getLanguage["AG"]["TUSB"]}}
                                    </CButton>
                                </span>
                            </td>
                            <td class="text-center">
                                <label class="switch" v-if="checkModuleAccess2(constAccessType.edit) && (getUserInfo.AT==0 || getUserInfo.AT==4) && data.PRS==2 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)">
                                    <input type="checkbox" :checked="checkStatus(data.RS)" @click="updateStatus(index)" v-model="data.RS" true-value="2" false-value="1">
                                    <span class="slider round"></span>
                                </label>
                                <span v-else :class="(data.RS == 2) ? 'positive-number': 'negative-number'">{{checkStatusTemp(data.RS)}}</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constStatus, constYesNo } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, sameAs, requiredIf, alphaNum, minLength, maxLength, between, decimal, email, minValue } from 'vuelidate/lib/validators';
    import { constAccessType, constSubAgentSchemeType, constSubAgentType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    function validatePassword(value) {
        if (this.obj_Group.Agent.UP != null && this.obj_Group.Agent.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_Group.Agent.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                int_RC: 20, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                arr_FV: {
                    "GN": "",
                    "PC": "",
                    "L": [],
                    "AL": "",
                    "AGI": null,
                    "SAGAGI": null,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    },
                }, //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                //sensBtn: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                str_prefixError: "",
                str_prefixCorrect: "",
                pc_msg_class: "ErrMsg",
                arr_Group: [],
                obj_Group: {
                    "I": 0,
                    "RS": 2,        //Status
                    "GN": "",       //Brand Name
                    "AT": "",       //Agent Type
                    "PGI": "",      //Parent Group Id
                    "PGIT": null,   //3-0304
                    "PC": "",       //Prefix Code
                    "WLIPS": "",    //White List Ip
                    "SPG": "",      //Sub Brand
                    "IOL": false,      //Outlet
                    "IGGE": false,     //GEarn
                    //"SAPSI": null,
                    //"L": "",
                    //"Language": null,
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "Contact": [{
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    },
                    {
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    }],
                    "SubAgentPayoutScheme": {
                        "PT": 0,
                        "WLT": 2,
                        "POT": 1
                    },
                    "SubAgentCustomPT": [],
                    "WhiteListIP": [],

                    //No required for Sub-Agent
                    //"PT": "0.0",
                    "DPT": "0.0",
                    "DCI": null,
                    "TB": "0.0",
                    "TCB": "0.00",
                    "CI": "",
                    "CurrencyIds": [],
                    "L": "",
                    "Language": [],
                    "GPI": "",
                    "GameProviderIds": [],
                    "LB": "0",
                    "ACT": "0",
                    "H2PU": "",
                    "H2PMC": "",
                    "H2PSC": "",
                    "H2PCC": "",
                    "OOPTHMN": "",
                    "OOPTHAS": "",
                    "OOPTHSK": "",
                    "OOPVIMN": "",
                    "OOPVIAS": "",
                    "OOPVISK": "",
                    "EZPIDRMN": "",
                    "EZPIDRAS": "",
                    "EZPMYRMN": "",
                    "EZPMYRAS": "",
                    "EZPTHBMN": "",
                    "EZPTHBAS": "",
                    "EZPVNDMN": "",
                    "EZPVNDAS": "",
                    "TUPVNDMN": "",
                    "TUPVNDAS": "",
                    "TUPMYRMN": "",
                    "TUPMYRAS": "",
                    "XFTHN": "",
                    "XFTHK": "",
                    "XFVIN": "",
                    "XFVIK": "",
                    "XFMYRN": "",
                    "XFMYRK": "",
                    "XFUSDTN": "",
                    "XFUSDTK": "",
                    "XFIDRN": "",
                    "XFIDRK": "",
                    "H2PCurrencyCodes": null,
                    "SAGAGI": null,
                    "CA": 0
                },
                bool_groupCV: false,
                dd_template: [],
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_agentgroupFilter: [],
                dd_status: [],
                dd_currency: [],
                dd_currencySupport: [],
                dd_languageSupport: [],
                ddSubBrandList: [],
                ddDefaultSubBrand: [],    //Defauld DD for Sub Brand
                rtSubBrand: 0,
                //dd_PayoutScheme: [],
                constAccessType: constAccessType,
                obj_WLIPS: {
                    WLIPS: null,
                },
                bool_houtLockSB:false,
                bool_houtprefixchange:false,
                str_houtOriPrefix:"",
                blnFCOC: false,
                constSubAgentSchemeType: constSubAgentSchemeType,
                constSubAgentType: constSubAgentType,
                selectedMaxPT: 0,
                selectedMinPT: 0,
                bool_cacheOptionValue: false,
                searchSubBrand: null,   //SubBrand AGI
                int_MaxLevel: null,
                arr_CustomProvider: [],

                ddSubBrandList2: [],
                ddDefaultSubBrand2: [],
                bool_isTopup: false, // Add Modal Visible
                obj_Balance: {
                    "I": 0,
                    "RS": 2,
                    "PAGI": "",
                    "PAGIT": null,
                    "AGI": "",
                    "AGIT": null,
                    "BT": 0,
                    "BU": 0.00,
                    "CB": null
                },
                str_availablebalance: '',
                dec_availablebalance: 0,
                str_currencysymbol: "",
                str_invalidAmountMsg: "",
                str_sagcreditbalance: '',
                dec_sagcreditbalance: 0,
                dd_access: [],
                bool_fullPreview: false,
                previewUrl: null,

                bool_showSSA: true,
                bool_showSPT: true,
                bool_showSSAUR: true,
                bool_showCL: true,

            }
        },
        validations: {
            obj_Group: {
                GN: { required },
                AT: { required },
                PGI: { required },
                DCI: { required },
                CA: { required },
                CurrencyIds: { required },
                Language: { required },
                SAGAGI: {
                    required: requiredIf(function (vm) {
                        if (!vm.PGIT) {
                            return false;
                        }
                        if (vm.PGIT.indexOf("-") > 0) {
                            var agi = vm.PGIT.split("-");

                            if (agi[0] == 4)
                                return true;
                            else
                                return false;
                        } else
                            return true;
                    })
                },
                PC: { required, minLength: minLength(8), maxLength: maxLength(8), alphaNum },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: value => !value || minLength(6)(value), validatePassword
                    },
                    CUP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0 && vm.UP != null && vm.UP != '';
                        }),
                        sameAsPassword: sameAs('UP')
                    },
                    DN: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    E: { email },
                },
                SubAgentPayoutScheme: {
                    PT: {
                        required,
                        between: function (val, obj) {
                            let res = true;
                            if (val) {
                                if (val < this.selectedMinPT || val > this.selectedMaxPT) {
                                    res = false;
                                }
                            }
                            return res;
                        }
                    },
                    WLT: { required },
                    POT: { required },
                },
            },
            obj_Balance: {
                AGIT: { required },
                BU: { required, decimal },
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isTopup() {
                if (!this.bool_isTopup && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            searchSubBrand() {
                this.bool_cacheOptionValue = false;
            },
            'obj_Group.GN': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.obj_Group.Agent.DN = val;

                    }
                }, deep: true
            },
            
            'obj_Group.IOL': function (val) {
                if (val == true) {
                    this.obj_Group.IGGE = false;
                }
            },

            'obj_Group.IGGE': function (val) {
                if (val == true) {
                    this.obj_Group.IOL = false;
                    this.obj_Group.SubAgentPayoutScheme.WLT = 1;
                }
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance'
            ]),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            selectSupportedCurrency(value, instanceId) {

            },
            checkStatus(RS) {
                return this.$parent.checkStatus(RS);
            },
            checkStatusTemp(RS) {
                if (RS==2) {
                    return this.getLanguage["GL"]["ENB"];
                }
                else {
                    return this.getLanguage["GL"]["DISB"];
                }
            },
            updateStatus(index) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CA"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        this.postDataApi(`/api/sag/ssastatus`, this.arr_Group[index],
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.arr_Group[index].UTS = d.UTS;
                                    that.getGroupList();
                                }
                            });

                    }
                    else {
                        this.arr_Group[index].RS = this.arr_Group[index].RS == 1 ? 2 : 1;
                    }
                 });
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SUB', 'AGS', type);
            },
            checkModuleAccess3(type) {
                return this.checkModuleAccess('ECG', 'AGS', type);
            },
            addMyIP() {
                var WLIPS_C = window.baseIP;
                var exist = false;

                this.obj_WLIPS = {
                    WLIPS: WLIPS_C
                }
                for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                    if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else {
                    this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                }
            },
            addWhiteListIP() {
                var exist = false;

                if (this.obj_Group.WLIPS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else if (!this.validateIP(this.obj_Group.WLIPS)) {
                    this.showErrorMessage(null, this.getLanguage["ERR"]["IIPF"], 1000);
                }
                else {
                    var WLIPS_C = this.obj_Group.WLIPS.trim();
                    this.obj_WLIPS = {
                        WLIPS: WLIPS_C
                    }
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                    }
                    else {
                        this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                        this.obj_Group.WLIPS = "";
                    }
                }
            },
            //Validate IP in IPv4 and IPv6 Format for Whitelist IP in addWhiteListIP()
            validateIP(ip) {
                return this.validateIPv4(ip) || this.validateIPv6(ip);
            },
            validateIPv4(ip) {
                const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                return ipv4Pattern.test(ip);
            },
            validateIPv6(ip) {
                const ipv6Pattern = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?::[a-fA-F0-9]{1,4}){1,6}|:(?::[a-fA-F0-9]{1,4}){1,7}|::$/i;
                return ipv6Pattern.test(ip);
            },
            removeWhiteListIP(index) {
                this.$delete(this.obj_Group.WhiteListIP, index);
                this.$forceUpdate();
            },
            ValidationGroupErrMsg(value, langKey = "") {
                if (value == "PC" && this.str_prefixError != "") {
                    return "";
                }
                
                if (this.bool_groupCV) {
                    var parent = "";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }

                    var validateObj = parent == "" ? this.$v.obj_Group[value] : this.$v.obj_Group[parent][value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        if (parent == "SubAgentPayoutScheme") {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["SAPS"][langKey]);
                        } else {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                        }
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return String.format(this.getLanguage["SUB"]['ERR8'], this.getLanguage["AG"][langKey]);
                        }
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('SAPS.ERRBTW'), this.getLanguage["SAPS"][langKey], this.selectedMinPT, this.selectedMaxPT);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            ValidatePrefixCode(callSave) {
                var that = this;
                var prefixCode = (this.obj_Group.PC).toUpperCase();
                this.str_prefixCorrect = '';
                this.pc_msg_class = 'ErrMsg';

                if (prefixCode.length == 8) {
 
                    this.getDataApi('/api/ag/chk/0/' + prefixCode,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (d.ERRC != "" && that.obj_Group.I == 0) {
                                //// prefix code duplicated
                                that.str_prefixError = String.format(that.utilGetErrorLanguage(d.ERRC), prefixCode);
                            }
                            else {
                                that.pc_msg_class = 'ValidMsg';
                                that.str_prefixError = "";
                                that.str_prefixCorrect = String.format(that.getLanguage["AG"]['VPC'], prefixCode);
                                if (callSave) {
                                    that.obj_Group.PC = prefixCode;
                                    that.saveGroupToServer();
                                }
                            }
                        });
                }
                else {
                    that.str_prefixError = String.format(this.getLanguage["SUB"]['ERR8'], this.getLanguage["AG"]["PC"]);
                }
            },
            GeneratePrefixCode() {
                var that = this;
                if(that.str_houtOriPrefix!=""){
                    that.obj_Group.PC=that.str_houtOriPrefix;
                }else{
                    this.getDataApi(`/api/ag/pc/8`,
                    function (d, s) {
                        if (s) {
                            that.obj_Group.PC = d.D;
                        }
                    });
                }
            },
            ParentGroupChange(value) {
                this.bool_fullLoading = false;
                var agi = 0;
                this.bool_cacheOptionValue = false;
                this.getMaxPT(1);
                this.searchSubBrand = null;

                if (value != "" && value != undefined) {
                    var agi = value.split("-")[1];
                    this.obj_Group.AGI = agi;
                } else {
                    this.obj_Group.AGI = 0;
                }

                this.obj_Group.CurrencyIds = [];
                this.getCurrencyDropdown(this.obj_Group.AGI)
                //if (agi.length > 0) {
                //    that.GetPayoutScheme(agi[1]);
                //}    
                //this.sensBtn = ((this.isSENS == 1 && agi != this.curAGI) ? true : false);
            },
            //GetPayoutScheme(agi) {
            //    var that = this;

            //    if (agi != null) {
            //        this.getDataApi(`/api/dd/ps-sub/${agi}`,
            //            function (d, s) {
            //                if (s) {
            //                    that.dd_PayoutScheme = that.deepClone(d.dropdownlist);
            //                }
            //            });
            //    }
            //},
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_groupCV = false;
            },
            closeAfterAdd() {
                this.bool_afterAdd = !this.bool_afterAdd;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getGroupList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getGroupList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getGroupList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;

                //this.dd_status = constStatus;
                this.dd_status = [{ id: '1', label: this.getLanguage['GL']['DISB'] }, { id: '2', label: this.getLanguage['GL']['ENB'] }];
                this.getAgentGroupDropdown();
            },
            getAgentGroupDropdown() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupFilter = that.deepClone(d.dropdownlist);

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });
            },
            getCurrencyDropdown(agi = 0) {
                var that = this;

                if (this.dd_currency.length == 0) {
                    this.getDataApi('/api/dd/cur/0',
                        function (d, s) {
                            if (s) {
                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT == false)
                                            that.dd_currency.push(d.dropdownlist[i]);
                                    }
                                }
                            }
                        });
                }

                if (agi > 0) {
                    this.dd_currencySupport = [];
                    this.getDataApi('/api/dd/cur/' + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_currencySupport = [];
                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT == false)
                                            that.dd_currencySupport.push(d.dropdownlist[i]);
                                    }
                                    that.dd_currencySupport = _.sortBy(that.dd_currencySupport, [item => item.label.toLowerCase()]);
                                }
                            }
                        });
                  
                    if (this.dd_currencySupport.length == 1) {
                        this.obj_Group.CurrencyIds = this.dd_currencySupport[0].id
                    }

                    this.dd_languageSupport = [];
                    this.getDataApi('/api/dd/lang/' + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_languageSupport = [];
                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT == false)
                                            that.dd_languageSupport.push(d.dropdownlist[i]);
                                    }
                                    that.dd_languageSupport = _.sortBy(that.dd_languageSupport, [item => item.label === "(EN) English" ? 0 : 1, item => item.label]);
                                }
                            }
                        });


                    if (this.dd_languageSupport.length == 1) {
                        this.obj_Group.Language = this.dd_languageSupport[0].id
                    }
                    
                }
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getGroupList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += "&f.PC=" + this.arr_FV["PC"];

                    if (this.arr_FV["AL"] > 0) {
                        path += "&f.AL=" + this.arr_FV["AL"]
                    }

                    if (this.arr_FV["SAGAGI"] != null) {
                        path += "&f.ATAGI=4-" + this.arr_FV["SAGAGI"]
                    } else if (this.arr_FV["AGI"] != null) {
                        path += "&f.ATAGI=" + this.arr_FV["AGI"]
                    }

                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }

                }

                this.getDataApi(`/api/sag/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Group = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                var loadLvel = 0;
                if(this.bool_isAMV){
                    loadLvel=-1
                }else{
                    loadLvel=20
                }

                if (this.obj_Group.AGI && (this.bool_isAMV || this.bool_isTopup)) {
                    parentAGI = this.obj_Group.AGI;
                }
                else if (this.arr_FV['AGI'] && (!this.bool_isAMV || !this.bool_isTopup)) {
                    parentAGI = this.arr_FV['AGI'].split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = this.arr_FV['SAGAGI'];
                }
                else {
                    this.ddSubBrandList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubBrandList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/0/${loadLvel}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubBrandList = d.dropdownlist;
                                that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubBrandList = [];
                            }

                            callback(null, that.ddSubBrandList);
                        });
                }
            },
            getMaxPT(agiChange = 0) {
                var that = this;
                var agi = 0;

                if (this.searchSubBrand > 0) {
                    agi = this.searchSubBrand;
                    this.obj_Group.SAGAGI = this.searchSubBrand;
                } else if (this.obj_Group.PGIT) {
                    agi = this.obj_Group.PGIT.split("-")[1];
                    this.obj_Group.SAGAGI = "";
                } else {
                    this.selectedMaxPT = 0;
                    return;
                }

                if (agi > 0) {
                    //Max Custom PT
                    if (agiChange == 1)
                        this.getCustomPTProvider(agi, 1);

                    //Max General PT
                    this.getDataApi(`/api/sag/g-maxpt/${agi}`,
                        function (d, s) {
                            if (s) {
                                that.selectedMaxPT = d.D.MaxPT;
                                if (that.searchSubBrand != null){
                                    that.obj_Group.IGGE = d.D.IGGE;
                                }                               
                                if(d.D.OEMI==2){
                                    if(that.obj_Group.I==0){
                                        that.obj_Group.PC=d.D.PC;
                                        that.obj_Group.DCI=d.D.DCI;
                                        that.bool_houtLockSB=true;
                                        that.obj_Group.IOL=false;
                                        that.str_houtOriPrefix=d.D.PC;
                                    }
                                    
                                }else{
                                    that.bool_houtLockSB=false;
                                    that.str_houtOriPrefix="";
                                }
                                
                            }
                        });

                    //Get supported currency
                    this.getCurrencyDropdown(agi);
                }
            },
            addGroup() {
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.bool_cacheOptionValue = false;
                this.obj_Group = {
                    "I": 0,
                    "RS": 2,
                    "GN": "",
                    "AT": "",
                    "PGI": "",
                    "PGIT": null,
                    "PC": "",
                    "WLIPS": "",
                    "SAGAGI": "",
                    "IOL": false,
                    "IGGE": false,
                    "hout_PrefixChange":false,
                    //"SAPSI": null,
                    //"L": "",
                    //"Language": null,
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "Contact": [{
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    }, {
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    }],
                    "SubAgentPayoutScheme": {
                        "PT": 0,
                        "WLT": 2,
                        "POT": 1
                    },
                    "WhiteListIP": [],
                    "DPT": "0.0",
                    "DCI": null,
                    "CI": "",
                    "CurrencyIds": [],
                    "Language": [],
                };
                // this.addMyIP();
                //this.dd_PayoutScheme = [],
                this.bool_fullLoading = false;
                this.bool_isAMV = true;
                this.searchSubBrand = null;   //SubBrand AGI
                this.ddSubBrandList = [];
                //Defauld DD for Sub Brand
                if (this.getUserInfo.AT == 4) {
                    this.loadDefaultSubBrand(0, true);
                } else {
                    this.ddDefaultSubBrand = [];
                }
                this.getCustomPTProvider(0, 0);

                if (this.dd_agentgroup[0].children == undefined) {
                    this.obj_Group.PGIT = this.dd_agentgroup[0].id;
                    this.ParentGroupChange(this.obj_Group.PGIT);
                }
            },
            domainList(agi, id, agentType) {
                this.$router.push("/AGS/CRD?agi=3-" + agi + "&sagi=" + id);
            },
            editGroup(data) {
                var id = data.I;
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                var that = this;
                this.loadDefaultSubBrand(0);
                this.getCustomPTProvider(id, 0);
                this.getCurrencyDropdown(data.PGI)

                this.getDataApi(`/api/sag/g/${id}`,
                    function (d, s) {
                        if (s) {
                            that.obj_Group = Object.assign(that.obj_Group, d.D);
                            
                            that.obj_Group.Agent = {
                                "I": -1,
                                "UP": "",
                                "CUP": ""
                            };

                            that.obj_Group.Contact = Object.assign(that.obj_Group.Contact, d.D.Contact);

                            if (that.obj_Group.CI != null && that.obj_Group.CI.length > 0) {
                                that.obj_Group.CurrencyIds = that.obj_Group.CI.split(',');
                            }
                            else {
                                that.obj_Group.CurrencyIds = [];
                            }

                            if (that.obj_Group.L != null && that.obj_Group.L.length > 0) {
                                that.obj_Group.Language = that.obj_Group.L.split(',');
                            }
                            else {
                                that.obj_Group.Language = [];
                            }

                            that.obj_Group.WhiteListIP = [];
                            if (that.obj_Group.WLIPS != "") {
                                var WLIPS_C = that.obj_Group.WLIPS;
                                that.obj_Group.WLIPS = "";
                                var WLIPS_CARRY = WLIPS_C.split(',');
                                for (var i = 0; i < WLIPS_CARRY.length; i++) {
                                    that.obj_WLIPS = {
                                        WLIPS: WLIPS_CARRY[i]
                                    }
                                    that.obj_Group.WhiteListIP.push(that.obj_WLIPS);
                                }
                            }
                            if (that.obj_Group.SPG != that.obj_Group.AAGI)
                                that.searchSubBrand = that.obj_Group.SPG;
                            else
                                that.searchSubBrand = null;
                            if (that.obj_Group.IOL == 1)
                                that.obj_Group.IOL = true;
                            else
                                that.obj_Group.IOL = false;
                            that.getMaxPT();
                            that.bool_isAMV = true;
                            that.bool_fullLoading = false;
                        }
                    });

            },
            saveGroup() {
                this.bool_fullLoading = true;
                if (this.obj_Group.PGIT != null && this.obj_Group.PGIT.length > 0) {
                    var agi = this.obj_Group.PGIT.split("-");
                    this.obj_Group.PGI = agi[1];
                    this.obj_Group.AT = 4;
                    this.obj_Group.SPG = this.searchSubBrand;
                    //this.obj_Group.AT = parseInt(agi[0]) + 1;
                }

                if (this.obj_Group.WhiteListIP != null && this.obj_Group.WhiteListIP.length > 0) {
                    this.obj_Group.WLIPS = "";
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (i != 0) {
                            this.obj_Group.WLIPS += ",";
                        }
                        this.obj_Group.WLIPS += this.obj_Group.WhiteListIP[i].WLIPS;
                    }
                }

                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }

                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }

                if (this.obj_Group.IOL)
                    this.obj_Group.IOL = 1;
                else
                    this.obj_Group.IOL = 0;

                if (this.obj_Group.IGGE && this.searchSubBrand == null) {
                    this.obj_Group.IGGE = 1;
                    this.obj_Group.GGET = 1;
                }
                else if (this.obj_Group.IGGE && this.searchSubBrand > 0) {
                    this.obj_Group.IGGE = 1;
                    this.obj_Group.GGET = 0;
                }
                else {
                    this.obj_Group.IGGE = 0;
                    this.obj_Group.GGET = 0;
                }

                if(this.str_houtOriPrefix==this.obj_Group.PC){
                    this.obj_Group.hout_PrefixChange=true;
                }else{
                    this.obj_Group.hout_PrefixChange=false;
                }

                //// check the require field
                this.obj_Group.SubAgentCustomPT = this.arr_CustomProvider;
                this.bool_groupCV = true;
                this.$v.obj_Group.$touch();
                if (!this.$v.obj_Group.$error) {
                    this.ValidatePrefixCode(true);
                } else {
                    this.bool_fullLoading = false;
                    //get the object for validating.
                    const validation = this.$v["obj_Group"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            saveGroupToServer() {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var that = this;  
                
                this.postDataApi(`/api/sag/s`, this.obj_Group,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.bool_isAMV = false;
                            if (that.obj_Group.IFCL && that.obj_Group.SAGCI > 0) {
                                that.postDataApi(`/api/sag/sc`, { "RS": 1, "I": that.obj_Group.SAGCI },
                                    function (d, s) {
                                        if (s) {
                                        }
                                    });
                            }

                            // reload agent group dropdown
                            that.getAgentGroupDropdown();

                            that.getGroupList();
                            //that.popUpAgentDetailModal(d.BD);
                        }
                    });
            },
            clearDateRangeFilter() {
                this.arry_FV.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            openBalanceHistoryList(data) {
                this.$router.push("/AGS/SubAgentCreditHistory?agi=" + data.AT + "-" + data.I + '&agn=' + encodeURIComponent('[' + data.AL + '] ' + data.GN + ' (' + data.PC + ')')  + '&pgit=3-' + data.AAGI + '&iol=' + (data.IOL ? '1' : '0'));
            },
            loadDefaultSubBrand(agi, isFirstLoad = false) {
                var that = this;
                var searchQuery = "0";
                var strAGI = agi.toString();

                var loadLvel =20;
                // var loadLvel = 0;
                // if(this.getUserInfo.OEMI==2 &&this.bool_isAMV){
                //     loadLvel=2
                // }else{
                //     loadLvel=20
                // }

                if (strAGI.indexOf("-") > 0) {
                    agi = agi.split("-")[1];
                }

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/0/${loadLvel}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;

                            if (isFirstLoad) {
                                that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                                that.searchSubBrand = that.ddDefaultSubBrand[0].id;
                                that.obj_Group.SAGAGI = that.ddDefaultSubBrand[0].id;
                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            }
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            getCustomPTProvider(agi = 0, isParent = 0) {
                var that = this;

                this.getDataApi(`/api/sag/gcpt/${agi}/${isParent}`,
                    function (d, s) {
                        if (s && d && d.D) {
                            that.arr_CustomProvider = d.D;
                        }
                        else {
                            that.arr_CustomProvider = [];
                        }
                    });
            },

            loadDefaultSubBrand2(agi, isFirstLoad = false) {
                var that = this;
                var searchQuery = "0";
                var strAGI = agi.toString();

                var loadLvel = 20;
                // var loadLvel = 0;
                // if(this.getUserInfo.OEMI==2 &&this.bool_isAMV){
                //     loadLvel=2
                // }else{
                //     loadLvel=20
                // }

                if (strAGI.indexOf("-") > 0) {
                    agi = agi.split("-")[1];
                }

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/0/${loadLvel}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand2 = d.dropdownlist;
                        }
                        else {
                            that.ddDefaultSubBrand2 = [];
                        }
                    });
            },
            loadSubBrandOptions2({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                var loadLvel = 0;
                if (this.bool_isTopup) {
                    loadLvel = -1
                } else {
                    loadLvel = 20
                }

                if (this.obj_Group.AGI && this.bool_isTopup) {
                    parentAGI = this.obj_Group.AGI;
                }
                else if (this.arr_FV['AGI'] && !this.bool_isTopup) {
                    parentAGI = this.arr_FV['AGI'].split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = this.arr_FV['SAGAGI'];
                }
                else {
                    this.ddSubBrandList2 = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubBrandList2 = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/0/${loadLvel}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubBrandList2 = d.dropdownlist;
                                that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubBrandList2 = [];
                            }

                            callback(null, that.ddSubBrandList2);
                        });
                }
            },
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            AgentGroupChange2(value) {
                this.bool_fullLoading = false;
                var that = this;
                var agi = 0;

                that.obj_Balance.CB = '';
                if (value != "" && value != undefined) {
                    var temp = value.split("-");
                    if (temp.length > 1 && temp[1] > 0) {
                        agi = temp[1];
                    }
                    else if (temp[0] > 0) {
                        agi = temp[0];
                    }
                }

                if (agi > 0) {
                    this.bool_fullLoading = true;
                    this.getDataApi(`/api/ag/gb-sub/${agi}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.dec_availablebalance = d.D.TB - d.D.BL;
                                that.str_availablebalance = that.formatNumber(that.dec_availablebalance, 2, d.D.CS);

                                that.dec_sagcreditbalance = d.D.CDBL;
                                that.str_sagcreditbalance = that.formatNumber(that.dec_sagcreditbalance, 2, d.D.CS);
                                that.obj_Balance.CB = that.str_sagcreditbalance;

                                that.str_currencysymbol = d.D.CS;
                                that.str_thousandSeparator = d.D.TS;
                                that.str_decimalSeparator = d.D.DS;
                                that.CurrencyChange(d.D.CS);
                            }
                        });
                }
            },
            adjustSystemBalance(data, balancetype) {

                this.obj_Balance = {
                    "I": 0,
                    "RS": 2,
                    "PAGI": data.AAGI.toString(),
                    "PGIT": '3-' + data.AAGI.toString(),
                    "AGI": data.I.toString(),
                    "AGIT": data.I.toString(),
                    "BT": balancetype,
                    "BU": null,
                    "CB": ''
                };

                if (data.I && data.I > 0) {
                    this.loadDefaultSubBrand2(0)
                    this.AgentGroupChange2(data.I.toString());
                }

                this.bool_isTopup = true;
            },
            ValidationSystemBalanceErrMsg(value, langKey = "") {
                if (this.bool_groupCV) {
                    var parent = "";
                    var key1 = "AG";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }
                    else if (langKey.indexOf(".") >= 0) {
                        var tempKey = langKey.split('.');
                        key1 = tempKey[0];
                        langKey = tempKey[1];
                    }

                    var validateObj = parent == "" ? this.$v[value] : this.$v[parent][value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('SAPS.ERRBTW'), this.getLanguage[key1][langKey], this.selectedMinBonus, this.selectedMaxBonus);
                    }

                    if (this.str_invalidAmountMsg != "" && (value == "BU" || value == "AA")) {
                        return this.str_invalidAmountMsg;
                    }
                }
            },
            AvailableBalanceAmount() {
                return '-' + this.str_sagcreditbalance + '  —  ' + this.str_availablebalance;
            },
            updateBalance() {
                if (this.obj_Balance.AGIT != null && this.obj_Balance.AGIT.length > 0) {
                    var agi = this.obj_Balance.AGIT.split("-");
                    if (agi.length == 2) {
                        this.obj_Balance.AGI = agi[1];
                    }
                    else {
                        this.obj_Balance.AGI = agi[0];
                    }
                }

                if (this.obj_Balance.BU == null) {
                    this.obj_Balance.BU = 0;
                }

                //// check the require field
                this.str_invalidAmountMsg = '';
                this.bool_groupCV = true;
                this.$v.obj_Balance.$touch();
                let isValid = true;

                if (!this.obj_Balance.BU || this.obj_Balance.BU == 0 || this.obj_Balance.BU > this.dec_availablebalance || this.obj_Balance.BU < (this.dec_sagcreditbalance * -1)) {
                    this.str_invalidAmountMsg = this.utilGetErrorLanguage('10031');
                    isValid = false;
                }

                if (!this.$v.obj_Balance.$error && isValid) {
                    this.bool_fullLoading = true;
                    var that = this;

                    this.postDataApi(`/api/ag/sagbh`, this.obj_Balance,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isTopup = false;
                                that.getGroupList();
                            }
                        });
                }
            },
            closeAdd1() {
                this.bool_isTopup = !this.bool_isTopup;
                this.bool_groupCV = false;
            },
            generateQRCode(value) {
                console.log(value)
                var parameter = "";
                var combinedDomain = "";

                var parts = value.toString().split('.');

                var lastPart = parts[parts.length - 1];

                //if the domain has /?rc= then it will take it out and replace it with ~
                if (lastPart.toString().includes('/?rc=')) {
                    var [domainPart, parameterPart] = lastPart.toString().split('/?rc=');

                    parts[parts.length - 1] = domainPart;

                    parameter = '~' + parameterPart;
                }

                this.bool_fullPreview = true;   

                var that = this;

                //replace every '.' with '_'
                for (var i = 0; i < parts.length; i++) {
                    combinedDomain += parts[i];

                    if (i < parts.length - 1) {
                        combinedDomain += '_';
                    }
                }

                //pass the domain and parameter (doesn't matter if it's empty)
                this.getDataApi(`api/ag/genqrcode/${combinedDomain}${parameter}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.previewUrl = d;
                        }
                    }
                );

            },
            closeQRCodePreview() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },

            showSectionBasedRole(type) {
                if (type === 'ssa') {
                    this.bool_showSSA = !this.bool_showSSA;
                    
                } else if (type === 'spt') {
                    this.bool_showSPT = !this.bool_showSPT;
                   
                } else if (type === 'ssaur') {
                    this.bool_showSSAUR = !this.bool_showSSAUR;
                    
                } else if (type === 'cl') {
                    this.bool_showCL = !this.bool_showCL;
                }
            },

            setCollapseExpandIcon(settingType) {
                let showUpArrow;

                if (settingType === 'SSA') showUpArrow = this.bool_showSSA;
                else if (settingType === 'SPT') showUpArrow = this.bool_showSPT;
                else if (settingType === 'SSAUR') showUpArrow = this.bool_showSSAUR;
                else if (settingType === 'CL') showUpArrow = this.bool_showCL;

                return showUpArrow ? "chevron-container chevron-up" : "chevron-container";
            }
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.SUB';

            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0, true);
                this.loadDefaultSubBrand2(0, true);
            }
            var parameters = this.$route.query;
            if (parameters.agi !== undefined) {
                this.arr_FV.AGI = parameters.agi;
            }
            this.getDropdownList();
            this.getCurrencyDropdown();
            this.getGroupList();
            this.isSENS = this.getUserInfo.ISENS;
            this.isOUTLET = this.getUserInfo.IOL;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true: false;
            this.curAGI = this.getUserInfo.AGI;
            this.setThousandCurrency(false);
            this.dd_access = [{ id: '1', label: this.getLanguage['AG']['SOFA'] }, { id: '2', label: this.getLanguage['AG']['SODA'] }];

            if (parameters.sagci && parameters.sagci > 0) {
                var that = this;
                this.bool_fullLoading = true;
                setTimeout(() => {
                    this.addGroup();

                    this.bool_fullLoading = false;
                    this.getDataApi(`/api/sag/gc/${parameters.sagci}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.obj_Group.IFCL = true;
                                that.obj_Group.SAGCI = parameters.sagci;
                                that.obj_Group.PGI = d.D.AGI;
                                that.obj_Group.PGIT = "3-" + d.D.AGI;
                                that.obj_Group.GN = d.D.DN;
                                that.obj_Group.DCI = d.D.CI;
                                that.obj_Group.Agent.U = d.D.U;
                                that.obj_Group.Agent.UP = d.D.UP;
                                that.obj_Group.Agent.CUP = d.D.UP;
                                that.obj_Group.Agent.DN = d.D.DN;
                                that.obj_Group.Agent.E = d.D.E;
                                that.obj_Group.Agent.PN = d.D.PN;
                                that.ParentGroupChange();

                                var SAGI = d.D.SAGI;
                                if (SAGI > 0) {
                                    that.getDataApi(`/api/dd/subbrand/0/0/${that.obj_Group.PGI}/`,
                                        function (d, s) {
                                            if (s && d && d.dropdownlist) {
                                                that.ddDefaultSubBrand = d.dropdownlist;
                                                that.bool_cacheOptionValue = true;
                                                that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                                                that.searchSubBrand = SAGI;
                                                that.obj_Group.SAGAGI = SAGI;
                                                that.getMaxPT(1);
                                            }
                                            else {
                                                that.ddDefaultSubBrand = [];
                                            }
                                        });
                                }
                            }
                        });
                }, 3000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/CreateSubAgent.vue